<script setup=""></script>

<template>
  <svg fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_240_2614)">
      <path d="M9.3652 11.9985H4.35938V27.9998H9.3652V11.9985Z" fill="currentColor" />
      <path
        d="M27.4016 19.4207V28H22.3957V20.0012C22.3957 17.8979 22.1432 16.1941 19.693 16.1941C17.2429 16.1941 16.9941 17.9017 16.9941 20.0012V28H11.9883V11.9987H16.9941V14.2868C17.748 12.6244 19.1729 11.5728 21.8077 11.5728C22.0112 11.5728 22.2073 11.5803 22.3957 11.5916C26.9153 11.8592 27.4016 15.2593 27.4016 19.4207Z"
        fill="currentColor"
      />
      <path
        d="M9.73333 6.86478C9.73333 5.28161 8.44795 4 6.86478 4C5.28161 4 4 5.28161 4 6.86478C4 8.44795 5.28161 9.72956 6.86478 9.72956C8.44795 9.72956 9.72956 8.44795 9.72956 6.86478H9.73333Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_240_2614">
        <rect fill="white" height="32" width="32" />
      </clipPath>
    </defs>
  </svg>
</template>
